import { useEffect } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { useAuth } from './app/hooks/useAuth'
import { useTypedSelector } from './app/hooks/useTypedSelector'
import { getCurrentUser } from './app/store/authSlice'
import { useAccess } from './app/hooks/useAccess'
import { siteMap } from './routing/siteMap'
import Loading from './app/components/common/loading/Loading'
import useSSE from './app/hooks/useImportSSE'

function App() {
  const { setMyself } = useAuth()
  const user = useTypedSelector(getCurrentUser())
  const { pageAccessMap } = useAccess()

  // -- Check if current user is authorizated
  useEffect(() => {
    setMyself()
  }, [])

  // --
  // -- SSE notifications
  const { start, stop } = useSSE()
  useEffect(() => {
    user ? start() : stop()
    return () => stop() // -- Close SSE connection when the app was unmounted
  }, [user?.idUser])

  return user === undefined ? (
    <Loading isfullScreen />
  ) : (
    <RouterProvider router={createBrowserRouter(siteMap(pageAccessMap))} fallbackElement={<> </>} />
  )
}

export default App
